module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (23).0b1c9e2f.jpg";